import ScorecardReportTableModel from 'scoreboard/reports/scorecard-report/scorecard-report-table-model'
import MassEditDataExtractor from './mass-edit-data-extractor'

const MassEditTableModel = ScorecardReportTableModel.extend({
	// override to prevent drilldown
	_drilldownSection: function() {
		return null
	},

	// override to add extra formatting to id and label columns
	dataExtractor: function(model) {
		return new MassEditDataExtractor(model)
	}
})
export default MassEditTableModel
MassEditTableModel.__filename__ = 'admin/mass-edit/mass-edit-table-model.js'
